import * as React from "react";
import { connect } from "react-redux";
import { RouteComponentProps, withRouter, Link } from "react-router-dom";
import * as redux from "redux";
import * as Comp from "../../../components";
import { Paths } from "../../../constants";
import * as M from "../../../models";
import { Api } from "../../../services/Api";
import { AppState } from "../../../store";
import { Utility } from "../../../utils";
import { AbstractSummary } from "../../abstracts/components";

const mapStateToProps = (state: AppState, ownProps: OwnProps | undefined): ConnectedState => ({
    ...Comp.Base.DefaultStatePropsMap(state, ownProps),
});

const mapDispatchToProps = (dispatch: redux.Dispatch<AppState>): ConnectedDispatch => ({
    ...Comp.Base.DefaultDispatchPropsMap(dispatch),
});

type OwnProps = RouteComponentProps<{
    guid: string;
}> & {
};

type ConnectedState = Comp.Base.DefaultConnectedState & {
};

type ConnectedDispatch = Comp.Base.DefaultConnectedDispatch & {
};

interface OwnState {
    abstract?: M.Abstract.Abstract;
    loadingAbstract: boolean;
    loadingType: boolean;
    type?: M.Abstract.AbstractType;
}

type CombinedProps = ConnectedState & ConnectedDispatch & OwnProps;

class DetailsComponent extends Comp.Base.BaseComponent<CombinedProps, OwnState> {
    public constructor(props: any) {
        super(props);
        this.state = {
            loadingAbstract: true,
            loadingType: true,
        };
    }

    public async componentDidMount() {
        this._isMounted = true;
        this.props.updateChildOfPath(Paths.User.Abstracts.UserAbstracts);
        const guid = this.props.match.params.guid;

        if (!Utility.isGuid(guid)) {
            this.props.notifyError("Invalid abstract identifier in URL");
            this.props.replace(Paths.User.Abstracts.UserAbstracts);
            return;
        }

        if (Utility.isGuid(guid)) {
            const userId = this.props.tokenData.userId || 0;
            const hasAccess = await M.Abstract.userHasAccessToAbstract(this.props.api, userId, guid);
            if (!hasAccess) {
                this.props.notifyError("You do not have access to the requested abstract.");
                this.props.replace(Paths.User.Abstracts.UserAbstracts);
                return;
            }
        }

        this.loadData();
    }

    public componentWillUnmount() {
        this._isMounted = false;
        this.props.updateChildOfPath();
    }

    public render() {
        const a = this.state.abstract;
        const type = this.state.type;
        const abstractGuid = (a && a.guid) || "";
        const eventId = a && a.eventId || 0;
        const allowEdits = a && a.editsAllowed;
        const allowUploads = a && a.uploadsAllowed;

        const abstractTypeTitle = type
            ? <h3>{type.name}</h3>
            : null;

        const abstractTitle = a
            ? <h1 dangerouslySetInnerHTML={{ __html: a.title }} />
            : null;

        const summary = a && type
            ? <AbstractSummary abstract={a} type={type} allowEdits={allowEdits} allowUploads={allowUploads} />
            : null;

        return <Comp.Page.PublicPage additionalClasses="full" pageTitle="Abstract details" style={{ minHeight: "150px", position: "relative" }}>
            <Comp.Generic.LoadingSpinner show={this.state.loadingAbstract || this.state.loadingType} />

            <Comp.Layout.ContentPrimary>

                {this.getErrorAlert()}

                <p><Link to={Paths.User.Abstracts.UserAbstracts}>&laquo; Your abstracts</Link></p>

                {abstractTitle}
                {abstractTypeTitle}

                <hr />

                {allowEdits
                    ? <p>
                        <Link className="action" to={Paths.AbstractsCompose(eventId, "review", abstractGuid)}>
                            <Comp.Generic.Icon icon="pencil" /> Edit
                        </Link>
                    </p>
                    : null}

                {allowUploads && !allowEdits
                    ? <p>
                        <Link className="action" to={Paths.AbstractsCompose(eventId, "uploads", abstractGuid)}>
                            <Comp.Generic.Icon icon="pencil" /> Upload
                        </Link>
                    </p>
                    : null}

                {summary}
            </Comp.Layout.ContentPrimary>

            <Comp.Layout.ContentSecondary>

            </Comp.Layout.ContentSecondary>
            <div className="clear"></div>
        </Comp.Page.PublicPage>;
    }

    private loadData() {
        const guid = this.props.match.params.guid;
        if (Utility.isGuid(guid)) {
            this.loadAbstract(guid);
            this.loadAbstractType(guid);
        }
    }

    private async loadAbstract(guid: string) {
        const result = await this.props.api.get(Api.endpoints.abstract.abstract.withUrlParams({ guid }));
        if (!this._isMounted)
            return;

        if (result.isSuccess && result.data) {
            this.setState({ ...this.state, abstract: result.data, loadingAbstract: false });
        }
        else {
            this.setState({ ...this.state, loadingAbstract: false }, () => {
                this.setErrors(M.Result.Result.errorsOrMessage(result), "Failed to load abstract");
            });
        }
    }

    private async loadAbstractType(guid: string) {
        const result = await this.props.api.get(Api.endpoints.abstract.typeByAbstractGuid.withUrlParams({ guid }));
        if (!this._isMounted)
            return;

        if (result.isSuccess && result.data) {
            this.setState({ ...this.state, type: result.data, loadingType: false });
        }
        else {
            this.setState({ ...this.state, loadingType: false }, () => {
                this.setErrors(M.Result.Result.errorsOrMessage(result), "Failed to load abstract type");
            });
        }
    }
}

export const Details: React.ComponentClass<OwnProps> = connect(mapStateToProps, mapDispatchToProps)(withRouter(DetailsComponent) as any);



// WEBPACK FOOTER //
// ./src/containers/user/abstracts/Details.tsx